<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useTour } from "@/composables/useTour.ts";
import { useAuthStore } from "@/store/auth/index.ts";
import { updateAbility } from "@/utils/casl/abilityFunctional.ts";

import ThemeSwitcher from "@/components/common/ThemeSwitcher.vue";

const route = useRoute();
const router = useRouter();
const { startTour } = useTour();
const authStore = useAuthStore();

const externalUrl = computed(() => {
  // @ts-ignore exclude-next-line
  if (!import.meta.env.VITE_APP_EXTERNAL_URL) return false;
  // @ts-ignore exclude-next-line
  return `${import.meta.env.VITE_APP_EXTERNAL_URL}${route.path}`;
});

const logout = () => {
  localStorage.removeItem("logged");
  localStorage.removeItem("accessToken");
  updateAbility([]);
  authStore.cleanUser();
  router.push("/login");
};

const deleteCookie = (name: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

const restartTour = () => {
  deleteCookie("introjs-dontShowAgain");
  startTour();
};
</script>

<template>
  <section class="flex flex-col gap-3">
    <div>
      <ThemeSwitcher class="styleForSwitch" />
    </div>
    <hr>
    <div class="flex flex-col gap-2">
      <div
        class="flex items-center px-1 py-1 border-2 border-primary bg-transparent text-primary hover:bg-primary hover:text-white rounded-md cursor-pointer shadow-md hover:shadow-lg transition-all duration-500"
        @click="restartTour"
      >
        <feather-icon
          type="refresh-ccw"
          size="20"
          class="pr-2"
        />

        Tour Reset
      </div>
      <a
        v-if="externalUrl"
        :href="externalUrl"
        target="_blank"
        class="flex items-center px-1 py-1 border-2 border-primary bg-transparent text-primary hover:bg-primary hover:text-white rounded-md cursor-pointer shadow-md hover:shadow-lg transition-all duration-500"
      >
        <feather-icon
          type="external-link"
          size="20"
          class="pr-2"
        />

        Old UI
      </a>
      <hr>
      <router-link
        :to="`/users/${authStore.user?.id}`"
        class="flex items-center px-1 py-1 border-2 border-primary bg-transparent text-primary hover:bg-primary hover:text-white rounded-md cursor-pointer shadow-md hover:shadow-lg transition-all duration-500"
      >
        <feather-icon
          type="user"
          size="20"
          class="pr-2"
        />
        Profile
      </router-link>
      <button
        class="flex items-center px-1 py-1 border-2 border-negative bg-transparent text-negative hover:bg-negative hover:text-white rounded-md cursor-pointer shadow-md hover:shadow-lg transition-all duration-500"
        @click="logout"
      >
        <feather-icon
          type="log-out"
          size="20"
          class="pr-2"
        />
        Logout
      </button>
    </div>
  </section>
</template>
